import { render, staticRenderFns } from "./AsideMenuList.vue?vue&type=template&id=471ad882&scoped=true&"
import script from "./AsideMenuList.vue?vue&type=script&lang=js&"
export * from "./AsideMenuList.vue?vue&type=script&lang=js&"
import style0 from "./AsideMenuList.vue?vue&type=style&index=0&id=471ad882&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471ad882",
  null
  
)

export default component.exports